import { createSearchWithCustomPropsAsyncFn } from '@common/search.services';
import { envConfigs } from '@config/envConfigs';
import { IItemResponse, IPagedResultsV1 } from '@gcl/react-core';
import { apiServerDelete, apiServerGet, apiServerPost, apiServerPut } from '@common/axios.services';
import { IResultResponse } from '@common/api.models';
import {
  IProject,
  IProjectInterested,
  IProjectSearchFilter,
  IProjectSearchFilterResponse,
  IUpdateProjectRequest,
} from './project.models';

export const apiRoutes = {
  getByProjectNo: '/Projects/ByProjectNo',
  getProjectDataAll: '/Projects/All',
  getProjectDataSearch: '/Projects/Search',
  projectWithId: (id: number) => `/Projects/${id}`,
  projectArchive: (id: number) => `/Projects/${id}/Archive`,
  projectUnarchive: (id: number) => `/Projects/${id}/Unarchive`,
  projectInterested: '/ProjectInterested',
  projectInterestedWithProjectId: (projectId: number) => `/ProjectInterested/${projectId}`,
};
export const getProjectDataAllAsync = async (): Promise<IPagedResultsV1<IProject>> => {
  const result = await apiServerGet<IPagedResultsV1<IProject>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectDataAll}`,
  );
  return result.data;
};
export const getProjectByProjectNoAsync = async (projectNo: string | undefined): Promise<IItemResponse<IProject>> => {
  const result = await apiServerGet<IItemResponse<IProject>>(`${envConfigs.apiBaseUrl}${apiRoutes.getByProjectNo}`, {
    params: { projectNo },
  });
  return result.data;
};

export const searchProjectAsync = createSearchWithCustomPropsAsyncFn<
  IProjectSearchFilter,
  IProjectSearchFilterResponse
>(apiRoutes.getProjectDataSearch);

export const putProjectAsync = async (request: IUpdateProjectRequest): Promise<IItemResponse<IProject>> => {
  const result = await apiServerPut<IItemResponse<IProject>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectWithId(request.id)}`,
    request,
  );
  return result.data;
};

export const putProjectArchiveAsync = async (id: number): Promise<IItemResponse<IProject>> => {
  const result = await apiServerPut<IItemResponse<IProject>>(`${envConfigs.apiBaseUrl}${apiRoutes.projectArchive(id)}`);
  return result.data;
};

export const putProjectUnarchiveAsync = async (id: number): Promise<IItemResponse<IProject>> => {
  const result = await apiServerPut<IItemResponse<IProject>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectUnarchive(id)}`,
  );
  return result.data;
};

export const postProjectInterestedAsync = async (projectId: number): Promise<IItemResponse<IProjectInterested>> => {
  const result = await apiServerPost<IItemResponse<IProjectInterested>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectInterestedWithProjectId(projectId)}`,
  );
  return result.data;
};

export const deleteProjectInterestedAsync = async (projectId: number): Promise<boolean> => {
  const result = await apiServerDelete<IResultResponse>(
    `${envConfigs.apiBaseUrl}${apiRoutes.projectInterestedWithProjectId(projectId)}`,
  );
  return result.data.isSuccess;
};
